module.exports = "/img/checkimage.b29cd698.png";